import { LicenseInfo } from "@mui/x-data-grid-premium";
import { createRoot } from "react-dom/client";

const container = document.getElementById("root");

LicenseInfo.setLicenseKey(
  "0b7d8832b2c146c6fa2ee663544550c0Tz05ODcwOCxFPTE3NTg3NTU4MTIwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
);

/**
 * Mounts the app into #root once window._APP_CONFIG is populated.
 */
function mountApp(): void {
  if (container == null) return;
  const root = createRoot(container);
  import("./app").then(({ App }) => {
    root.render(<App />);
  });
}

// env.json is the primary config source; env.js (window._APP_CONFIG, set by the
// <script src="/env.js"> tag in index.html) is the fallback, used only when
// env.json is missing or unparseable.
fetch(`${location.origin}/env.json`)
  .then((response) => response.json())
  .then((json) => {
    window._APP_CONFIG = json;
    mountApp();
  })
  .catch(() => {
    // env.json unavailable — fall back to env.js (window._APP_CONFIG).
    if (window._APP_CONFIG) {
      mountApp();
    }
  });
